import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import SEO from '../../../components/seo'

import axios from 'axios'

import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'

import Layout from '../../../components/layout/layout'
import NextPreviousRow from '../../../components/next-previous'
import PageTitle from '../../../components/page-title'

import isUserSignedIn from '../../../auth/is-user-signed-in'

import StudentContent from '../../../components/layout/student-content'
import TeacherContentStudentAccordion from '../../../components/layout/teacher-content/teacher-content-student-accordion'
import TeacherContentTeacherAccordion from '../../../components/layout/teacher-content/teacher-content-teacher-accordion'
import Video from '../../../components/video'

// eslint-disable-next-line
import threedmssImage from '../../../queries/threedmssImage'

const Page = class extends Component {
  constructor(props) {
    super(props)

    this.state = {
      student_accordion_open: true,
      authenticated: undefined
    }

    this.axios_cancel_token = axios.CancelToken.source()
  }

  async componentDidMount () {
    const is_signed_in = isUserSignedIn()
    this.setState({authenticated: is_signed_in})
  }

  render() {
    const { location } = this.props
    if (this.state.authenticated === undefined) {
      return (
        <React.Fragment>
          <Layout>
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <Row className="mb-3 justify-content-center w-100">
                <div className="spinner-grow text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </Row>
            </Container>
          </Layout>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <SEO title="Conclusion&mdash;A Happy Ending for M'Kenna" />
          <Layout
            location={location}
            course="threedmss"
            setStudentAccordionState={(state) => this.setState({student_accordion_open: state})}
            setAuthenticated={(is_signed_in) => this.setState({authenticated: is_signed_in})}
          >
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <PageTitle title="Conclusion&mdash;A Happy Ending for M'Kenna" no_breadcrumb={true} />
              <Row style={{ marginBottom: '2rem' }}>
                {this.state.authenticated &&
                  <React.Fragment>
                    <Col xs={12} lg={6} id="student-accordion-column">
                      <TeacherContentStudentAccordion
                        title="Student View"
                        open={this.state.student_accordion_open}
                        setStudentAccordionState={() => {
                          /*
                            Anytime this is called, it's toggling so I'm just setting it to the opposite of its current state. This is to sync the student accordion state with the ToggleStudentView component.  Pretty much just don't worry about it. Keep walking.
                          */
                          if (this.state.student_accordion_open) {
                            this.setState({student_accordion_open: false})
                          } else {
                            this.setState({student_accordion_open: true})
                          }
                        }}
                      >
                        <div className="row">
                          <div className="col-12">
                            <hr className="focus-question-heading bold-me d-none d-md-block d-lg-none d-xl-block" />
                            <h3 className="bold-me d-block d-md-none d-lg-block d-xl-none text-center">Focus Question</h3>
                            <hr className="d-block d-md-none d-lg-block d-xl-none" />
                            <p className="focus-question bold-me">When and how do body systems work together?</p>
                            <hr className="after-focus-question" />
                          </div>

                          <div className="col-12">
                            <div className="image-wrapper">
                            <Img
                              fluid={this.props.data.image1.childImageSharp.fluid}
                              alt="This is a photo of M'Kenna after she regained her health."
                              className="image image-bordered"
                            />
                            <div className="image-caption image-caption-bordered">
                              Eventually, M'Kenna recovered. She regained the weight she lost and was able to start playing basketball and running track again.
                            </div>
                            </div>
                          </div>

                          <div className="col-12">
                            <p>You've learned a lot about M'Kenna and in the process, learned a lot about body systems, too! M'Kenna is a real person. This unit is based on a real medical mystery.</p>
                          </div>
                        </div>

                        <div className="col-12">
                          <p className="list-heading bold-me underline-me my-4">On your own</p>
                          <ol>
                            <li>Your teacher will give you a short reading about M'Kenna. Read and answer the questions on the handout.</li>
                            <li>Tape your reading and answers in your science notebook.</li>
                          </ol>

                          <p className="list-heading bold-me underline-me my-4">With your class</p>
                          <ol start="3">
                            <li>Have you ever met anyone with the illness that M'Kenna has? If so, share your story with your classmates. About 1 out of every 100 people have this illness. Many of them don't even know they have it.</li>
                          </ol>
                        </div>
                      </TeacherContentStudentAccordion>
                    </Col>
                    <Col xs={12} lg={6} name="teacher-accordion-column">
                      <Container fluid>
                        <Row>
                          <TeacherContentTeacherAccordion title="Time Estimate" open={true}>
                            <p>Estimated time to complete this web page: 30 min</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Before You Teach" open={true}>
                            <p>Make copies of handout <a href="https://media.bscs.org/3dmss/te/documents/04_tog/mkenna_reading.pdf" target="_blank" rel="noopener noreferrer"><span className="italic">Who is M'Kenna and What Happened to Her?</span>&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a>.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Background Information">
                            <p><span className="bold-me">Celiac Disease</span></p>

                            <p>Celiac disease, sometimes called sprue, is a digestive disorder that damages the small intestine. As many as one in 141 Americans has celiac disease, though most are unaware of it. The disease is triggered by eating foods that contain gluten, a protein found in wheat, barley, and rye. Many pre-packaged foods, lip balms, hair and skin products, toothpastes, and vitamin and nutrient supplements contain gluten. Celiac disease can involve long-lasting digestive problems and prevent an affected person from getting all the nutrients they need to be healthy.</p>

                            <p>The symptoms of celiac disease are similar to some other digestive problems which can complicate getting an accurate diagnosis. Some people experience gluten sensitivity or wheat intolerance, which have symptoms similar to celiac disease. However, gluten sensitivity does not damage the small intestine. Celiac disease is also different from a wheat allergy. Although both disorders involve an inappropriate response of the immune system, wheat allergy causes some symptoms not associated with celiac disease, such as itchy eyes or difficulty breathing. A wheat allergy also do not cause long-term damage to the small intestine.</p>

                            <p><span className="bold-me italic">Symptoms of Celiac Disease</span></p>

                            <p>People with celiac disease do not all display the same symptoms. In fact, some people with the disease do not even display symptoms or feel sick. Sometimes, a health issue such as surgery, childbirth, infection, or severe mental stress can trigger symptoms of celiac disease. Both children and adults may develop celiac disease. Digestive symptoms are more common in children and may include:</p>
                            <ul>
                              <li>bloating</li>
                              <li>chronic diarrhea</li>
                              <li>constipation</li>
                              <li>gas</li>
                              <li>nausea</li>
                              <li>pale, foul-smelling stools</li>
                              <li>stomach pain</li>
                              <li>vomiting</li>
                            </ul>

                            <p>Children with celiac disease cannot absorb all the nutrients they need. This can lead to complications such as:</p>
                            <ul>
                              <li>damage to teeth enamel</li>
                              <li>delayed puberty</li>
                              <li>failure to thrive in infants</li>
                              <li>mood changes</li>
                              <li>slowed growth</li>
                              <li>weight loss</li>
                            </ul>

                            <p>Complications often seen among adults with celiac disease include:</p>
                            <ul>
                              <li>anemia</li>
                              <li>bone or joint pain</li>
                              <li>depression</li>
                              <li>headaches</li>
                              <li>infertility</li>
                              <li>canker sores or dry mouth</li>
                              <li>numbness in hands and feet</li>
                              <li>tiredness</li>
                            </ul>

                            <p>The adults with celiac disease who experience digestive symptoms may experience:</p>
                            <ul>
                              <li>abdominal pain and bloating</li>
                              <li>intestinal blockages</li>
                              <li>chronic tiredness</li>
                              <li>stomach ulcers</li>
                            </ul>

                            <p>Celiac disease is associated with an inappropriate immune response that can lead to the immune system attacking healthy cells located in areas outside of the digestive system such as in the joints, nervous system, skin, and spleen. There are several reasons why the collection of disease symptoms varies so much between people. These reasons include</p>
                            <ul>
                              <li>variation in the amount of gluten consumed,</li>
                              <li>the age at which gluten was first eaten,</li>
                              <li>the amount of damage to the small intestine, and</li>
                              <li>the length of time that an infant was breastfed; some studies suggest that infants breastfed for longer periods of time manifest symptoms later.</li>
                            </ul>

                            <p><span className="bold-me italic">Causes of Celiac Disease</span></p>

                            <p>Celiac disease is a genetic disease in the sense that it occurs in people who have certain gene variants. These gene variants (alleles) are common and are carried by approximately one third of the population. Even if a person has this set of alleles, she/he will not get celiac disease unless gluten is consumed over a prolonged period. It is not understood what exactly triggers the disease. It is believed that infant feeding practices, gastrointestinal infections, and gut bacteria all may contribute to developing the disease. Celiac disease seems to run in some families. About 10 to 20 percent of close relatives of people with celiac disease are also affected. Sometimes celiac disease becomes active for the first-time following surgery, childbirth, viral infection, or severe mental stress.</p>

                            <p>Once the disease is triggered, the immune system overreacts and attacks healthy tissue in the small intestine. The resulting inflammation damages the tiny hair-like projections (villi) that line the small intestine. As the disease progresses, the villi become shortened and flatten out. The damaged villi are not able to properly absorb nutrients. A patient may not be able to obtain enough nutrients no matter how much food they eat.</p>

                            <p><span className="bold-me italic">Diagnosis of Celiac Disease</span></p>

                            <p>As mentioned earlier, the diagnosis of celiac disease can be complicated by the fact that its symptoms are similar to other disorders such as irritable bowel syndrome and lactose intolerance. Doctors diagnose celiac disease based on medical and family history and the results of a physical exam and laboratory tests.</p>

                            <p><span className="italic">Medical and family history</span></p>

                            <p>Not surprisingly, doctors will want to know about the general health of family members and especially if any have a history of celiac disease.</p>

                            <p><span className="italic">Physical exam</span></p>

                            <p>During a physical exam a doctor considering celiac disease will look for signs of malnutrition, listen for sounds in the abdomen, and tap on the abdomen to check for pain or swelling. In some cases, the first indication of celiac disease comes from a visit to the dentist. White, yellow, or brown spots on teeth enamel are sometimes seen, especially among children.</p>

                            <p><span className="italic">Laboratory tests</span></p>

                            <p>Celiac disease is fairly rare and people with no symptoms are not usually screened for it.  However, screening may be recommended for blood relatives of people with celiac disease or for those with type 1 diabetes, since they are at increased risk.</p>
                            <ul>
                              <li>Blood tests look for antibodies that are associated with celiac disease.</li>
                              <li>To confirm the results of a positive blood test, a doctor may perform an intestinal biopsy. In this procedure, a small piece of tissue is removed from the small intestine and examined for signs of celiac disease.</li>
                              <li>Genetic tests can also be used to look for celiac disease. If patients are not found to have gene variants associated with celiac disease, then it is likely not present. However, if these gene variants are detected, it doesn't necessarily mean that the patient has the disease. In fact, most people who have these gene variants do not develop celiac disease.</li>
                            </ul>

                            <p><span className="bold-me italic">Management of Celiac Disease</span></p>

                            <p>The only effective treatment for celiac disease is to eat a gluten-free diet. A dietitian can help a patient learn to read food labels, design a meal plan, and make healthy decisions about which foods to eat. Patients who closely follow the diet may experience symptom improvement in days to weeks. The small intestine may require several months to heal in children, while adults may not see complete healing for several years.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Where are we in the storyline?" open={true}>
                            <p>We are at the conclusion of M'Kenna's story. Students have used what they learned in the unit to explain M'Kenna's symptoms. Now students learn the condition that M'Kenna has and use some applications of the condition, the damage to her body, and her symptoms to answer additional questions about M'Kenna and her disease. Students still struggling to meet the performance expectation should have additional chances to demonstrate their mastery in responding to the questions within the reading.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Phenomenon for This Lesson" open={true}>
                            <p>When something goes wrong in one body system, it can affect <span className="bold-me">all</span> other systems in the body.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Main Learning Goal" open={true}>
                            <p>While body systems have their own unique function, they also work together in a variety of ways to keep cells alive. When something goes wrong in one body system, it affects other body systems.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During Lesson: Steps 1-2" open={true}>
                            <div className="row">
                              <div className="col-12 mb-4">
                                <hr style={{margin: '10px 0'}} />
                                <div className="text-center">
                                  {/* For multiple icons: Every icon except the last one should have margin-right: 1rem; */}
                                  {/* For a single icon, leave margin-right: 1rem; out all together. */}
                                  <img src="https://media.bscs.org/3dmss/te/icons/practice-icon.svg" alt="Practice icon." style={{width: '42px'}} />
                                  <span className="sr-only">Practice Icon</span>
                                </div>
                                <hr style={{margin: '10px 0'}} />
                              </div>

                              <div className="col-12 mb-4">
                                <span className="sr-only">Practice icon</span>
                                <h3 className="section-heading bold-me text-center">Obtaining, evaluating, and communicating information.</h3>
                              </div>

                              <ol type="A">
                                <li>Distribute the <span className="italic">Who is M'Kenna and What Happened to Her?</span> reading. We purposely didn't put a link to the reading in the student edition. We didn't want students to be able to skip to the end and get the answer. We do want them to know the end of the story. In <span className="bold-me">step 1</span>, students can read independently, in small groups, or as a class. Use your own judgement about what works best for your students.<br /> <br />There are a few questions embedded in the reading that students should answer (again, they can answer independently or work together in groups to answer the questions). If you are using their responses as another opportunity for struggling students to demonstrate mastery of the PE, ensure that those students are working independently.</li>
                                <li>In <span className="bold-me">step 2</span>, students should attach the reading to their notebooks.</li>
                              </ol>
                            </div>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During Lesson: Step 3, Discussion">
                            <ol type="A" start="3">
                              <li>The class discussion at the end is an opportunity for students to share their own stories about friends or family members with celiac disease. It's helpful if you can make the point that all sorts of people–young, old, rich, poor, and from all racial and ethnic groups–can have celiac disease. The only "cure" for people with celiac disease is to avoid gluten. Note that this is really not a cure; M'Kenna will always have the disease, but she can manage her symptoms by avoiding gluten in her diet. Doing so allows her body to repair the small intestine so she can become healthy and active again.</li>
                              <li>You may want to show this video of an interview with M'Kenna. She answers questions that one class of students submitted to her after they completed this unit.</li>
                            </ol>

                            <Video vimeo_id="412459004" />
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Post Assessment (optional)">
                            <p>Administer the posttest (optional). If you administered the unit level pretest, you may also want to administer the posttest. If you did not administer the unit level pretest, you may want to give this posttest as an additional unit assessment. This assessment is identical to the pretest included in the unit introduction. This posttest will take a full class period to complete. We have included a rubric and guidance so that you can assess your students' progress in meeting the goals of all three dimensions of the NGSS.</p>
                          </TeacherContentTeacherAccordion>
                        </Row>
                      </Container>
                    </Col>
                  </React.Fragment>
                }
                {!this.state.authenticated &&
                  <StudentContent>
                    <div className="row">
                      <div className="col-12">
                        <hr className="focus-question-heading bold-me" />
                        <p className="focus-question bold-me">When and how do body systems work together?</p>
                        <hr className="after-focus-question" />
                      </div>

                      <div className="col-12">
                      <div className="image-wrapper-right">
                        <Img
                          fluid={this.props.data.image1.childImageSharp.fluid}
                          alt="This is a photo of M'Kenna after she regained her health."
                          className="image image-bordered"
                        />
                        <div className="image-caption image-caption-bordered">
                          Eventually, M'Kenna recovered. She regained the weight she lost and was able to start playing basketball and running track again.
                        </div>
                      </div>


                        <p>You've learned a lot about M'Kenna and in the process, learned a lot about body systems, too! M'Kenna is a real person. This unit is based on a real medical mystery.</p>


                      <p className="list-heading bold-me underline-me my-4">On your own</p>
                      <ol>
                        <li>Your teacher will give you a short reading about M'Kenna. Read and answer the questions on the handout.</li>
                        <li>Tape your reading and answers in your science notebook.</li>
                      </ol>

                      <p className="list-heading bold-me underline-me my-4">With your class</p>
                      <ol start="3">
                        <li>Have you ever met anyone with the illness that M'Kenna has? If so, share your story with your classmates. About 1 out of every 100 people have this illness. Many of them don't even know they have it.</li>
                      </ol>
                      </div>
                    </div>
                  </StudentContent>
                }
              </Row>
              <NextPreviousRow location={location} authenticated={this.state.authenticated} />
            </Container>
          </Layout>
        </React.Fragment>
      )
    }
  }
}

export default Page

export const query = graphql`
  query {
    image1: file(relativePath: { eq: "04_tog/1650_H.jpg" }) {
      ...threedmssImage
    }
  }
`
